import 'honeybadger'; // Load first for subsequent error reporting.
import 'bootstrap';
import 'blog';
import 'traffic_source';
import 'affiliate_source';
import ahoy from 'ahoy.js'

import 'main.scss';

// Util: console.debug wrapper
function debug() {
  let console = window.console;
  if (console && typeof console.debug === 'function') {
    const args = Array.prototype.slice.call(arguments);
    console.debug.apply(console, args);
  }
}

// DPA Form
$('#dpa-form').on('submit', function (e) {
  e.preventDefault();

  var inputs,
    key,
    data = {};
  for (key in (inputs = $(e.target).serializeArray())) {
    data[inputs[key]['name']] = inputs[key]['value'];
  }

  if (data['authorized'] !== 'yes') {
    alert(
      'You must be authorized to sign on behalf of this company in order to generate a data processing agreement.',
    );
    return;
  }

  $('#submit').attr('disabled', true);
  $('#spinner').show();

  $.post({
    url:
      'https://rzssyd3w33.execute-api.us-east-1.amazonaws.com/production/process',
    data: JSON.stringify(data),
    datatype: 'json',
    success: function (data, status, xhr) {
      $('#spinner, #form-container').hide();
      $('#success-container').show();
    },
    error: function (data) {
      $('#spinner').hide();
      alert('Error encountered: ' + data.responseJSON.message);
      $('#submit').attr('disabled', false);
    },
  });
});

// Change the pricing attributes on body tag
$('body').on('click', '[data-contract]', function (event) {
  let contract = $(event.currentTarget).attr('data-contract');
  $('body').attr('data-current-contract', contract);
  $('[data-contract]').removeClass('active');
  $(`[data-contract=${contract}]`).addClass('active');
});
$('body').on('click', '[data-size]', function (event) {
  let size = $(event.currentTarget).attr('data-size');
  $('body').attr('data-current-size', size);
  $('[data-size]').removeClass('active');
  $(`[data-size=${size}]`).addClass('active');
});

// Breadcrumbs
$('body').on('click.breadcrumb.has-metadata', (evt) => {
  $(evt.target)
    .parents('.breadcrumb')
    .toggleClass('metadata-open');
});

// Stub fathom if it wasn't loaded for some reason (i.e. ad blocker)
document.addEventListener("DOMContentLoaded", function(){
  if (!window.fathom) {
    window.fathom = {
      trackGoal: function() {}
    };
  }
});

// Ahoy.js
// See https://github.com/ankane/ahoy.js
window.ahoy = ahoy;

// https://github.com/ankane/ahoy.js/issues/43
// Note: this suggested fix for CORB warnings in Chrome didn't work: https://github.com/ankane/ahoy.js/issues/66#issuecomment-964306788
ahoy.configure({
  urlPrefix: "https://app.honeybadger.io",
  visitsUrl: "/ancient-frost-1484/visits",
  eventsUrl: "/ancient-frost-1484/events",
  cookieDomain: "honeybadger.io",
  withCredentials: true,
  startOnReady: true
});

ahoy.trackView();
ahoy.trackClicks("a, button, input[type=submit]");
